import { sendSumoLog } from './sumoLogger';
import { updateNotifList, updateError } from '../../stores/notifications';

export const fetchTicketNotifList = async (token, dispatch) => {
  const requestUrl = encodeURI(
    `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/ticket-notification/notificationList`
  );
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
  });

  try {
    const data = await fetch(requestUrl, {
      method: 'GET',
      headers,
    });

    if (!data.ok) {
      throw {
        message: `Ticket Notif List Fetch Data Not Okay: ${data.status}`,
        code: data.status,
      };
    }

    const jsonData = await data.json();
    updateNotifList(jsonData, dispatch);
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorMessage = isInternalError ? error.toString() : error.message;

    sendSumoLog(
      'fetchTicketNotifList',
      errorMessage,
      isInternalError ? 500 : error.code,
      dispatch,
      false
    );

    updateError(error, dispatch);
  }
};
